import { render, staticRenderFns } from "./InteractionPackage.vue?vue&type=template&id=83ccd132&scoped=true&"
import script from "./InteractionPackage.vue?vue&type=script&lang=js&"
export * from "./InteractionPackage.vue?vue&type=script&lang=js&"
import style0 from "./InteractionPackage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./InteractionPackage.vue?vue&type=style&index=1&id=83ccd132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ccd132",
  null
  
)

export default component.exports